import alerts from './alertsReducer';

export default {
  alerts
};
